<h1 mat-dialog-title>Inscribir cédula de identidad</h1>
<div mat-dialog-content class="text-default-gray flex flex-col items-center w-full max-w-xl">
    <p class="mx-0 my-3">
        Por motivos de seguridad, para comprar en esta tienda es necesario inscribir tu
        cédula de identidad. ¿Deseas proceder?
    </p>
    <div class="flex flex-col gap-2 w-full">
        <button mat-raised-button [mat-dialog-close]="true" color="primary">{{ 'common.buttons.confirm' | translate | uppercase }}</button>
        <button mat-stroked-button [mat-dialog-close]="false" color="">{{ 'common.buttons.cancel' | translate | uppercase }}</button>
    </div>
</div>
